import Controller from '@ember/controller';

export default class PostController extends Controller {}
